var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFolderDotted = function SvgIconFolderDotted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.663 3.125a1.75 1.75 0 0 1 1.31.59h.001l2.773 3.12A1 1 0 0 1 12 8.5H3a1 1 0 0 1-1-1V4.875a1.75 1.75 0 0 1 1.75-1.75zm-.112 2L9.773 6.5H4V5.125z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 7.5a1 1 0 0 1 1-1h4.5A1.75 1.75 0 0 1 22 8.25v2.25a1 1 0 1 1-2 0v-2h-4.25a1 1 0 0 1-1-1M3 10.25a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1M21 13.25a1 1 0 0 1 1 1v4.584a1.665 1.665 0 0 1-1.666 1.666H18.75a1 1 0 1 1 0-2H20v-4.25a1 1 0 0 1 1-1M3 17a1 1 0 0 1 1 1v.5h4.25a1 1 0 1 1 0 2H3.694A1.694 1.694 0 0 1 2 18.806V18a1 1 0 0 1 1-1M11 19.5a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconFolderDotted;